import config from "config";
import gsap from "gsap";
import { PreloaderHelper } from "shared/helpers";

export class Tutorial {
    private static currentData = {
        spans: [],
        slide: 0,
        transform: 0,
    }
    private static newNodes: any[] = [];
    public static addContent(slides: { img: string, text: string }[], screen: PIXI.Container): void {
        this.currentData = {
            spans: [],
            slide: 0,
            transform: 0,
        }
        const tutorial = document.getElementById('tutorial');
        const slider = document.getElementById('slider');
        const sliderNav = document.getElementById('slider_nav');
        const tutorialText = document.getElementById('tutorialText');
        const startBtn = document.getElementById('startLevel');
        const nextTipBtn = document.getElementById('nextTip');
        
        for (let i = 0; i < slides.length; i++) {
            const img = document.createElement('img');
            this.newNodes.push(img);
            img.src = slides[i].img;
            img.draggable = false;
            slider.appendChild(img);

            if (slides.length > 1) {
                startBtn.style.display = 'none';
                nextTipBtn.style.display = 'block';
                const span = document.createElement('span');
                this.newNodes.push(span);
                span.classList.add('el');
                this.currentData.spans.push(span);
                if (i === 0) {
                    span.classList.add('active');
                    tutorialText.textContent = slides[i].text;
                }
                span.addEventListener('click', () => {
                    this.changeSlide(i, span, slides[i].text)
                });



                sliderNav.appendChild(span);
            } else {
                tutorialText.textContent = slides[i].text;
                startBtn.style.display = 'block';
            }

        }

        let touch_x ;
        slider.addEventListener('touchstart', (e) => {
            touch_x = e.changedTouches[e.changedTouches.length - 1].clientX;
            
        })

        slider.addEventListener('mousedown', (e) => {            
            touch_x = e.pageX;
        })
        slider.addEventListener('touchend', (e) => {
            let touchEnd_x = e.changedTouches[e.changedTouches.length - 1].clientX;
            if (touchEnd_x < touch_x && e.type=='touchend' && Math.abs(touch_x-touchEnd_x)>3) {
                if (slides[this.currentData.slide + 1]) {
                    const newSlide = slides[this.currentData.slide + 1];
                    this.changeSlide(this.currentData.slide + 1, this.currentData.spans[this.currentData.slide + 1], newSlide.text)
                }
            } else if (touchEnd_x > touch_x && e.type=='touchend' && Math.abs(touch_x-touchEnd_x)>3) { 
                if (slides[this.currentData.slide - 1]) {
                    const newSlide = slides[this.currentData.slide - 1];
                    this.changeSlide(this.currentData.slide - 1, this.currentData.spans[this.currentData.slide - 1], newSlide.text)
                }
            }
        })

        slider.addEventListener('mouseup', (e) => {                        
            let touchEnd_x = e.pageX;
            if (touchEnd_x < touch_x && e.type=='mouseup' && Math.abs(touch_x-touchEnd_x)>3) {
                if (slides[this.currentData.slide + 1]) {
                    const newSlide = slides[this.currentData.slide + 1];
                    this.changeSlide(this.currentData.slide + 1, this.currentData.spans[this.currentData.slide + 1], newSlide.text)
                }
            } else if (touchEnd_x > touch_x && e.type=='mouseup' && Math.abs(touch_x-touchEnd_x)>3) { 
                if (slides[this.currentData.slide - 1]) {
                    const newSlide = slides[this.currentData.slide - 1];
                    this.changeSlide(this.currentData.slide - 1, this.currentData.spans[this.currentData.slide - 1], newSlide.text)
                }
            }
        })

        nextTipBtn.addEventListener('click', () => {
            this.nextSlide(slides, nextTipBtn, startBtn);
        })
    }

    private static nextSlide(slides, nextTipBtn, startBtn): void {
        const slide = this.currentData.slide;
            const span = this.currentData.spans[slide];
            const newSlide = slide + 1;
            const newSpan = this.currentData.spans[newSlide];
            const slider = document.getElementById('slider');
            const transform = newSlide * 100;
            const activeSpan = document.getElementsByClassName('active')[0];
            const tutorialText = document.getElementById('tutorialText');
            activeSpan.classList.remove('active');
            newSpan.classList.add('active');
            tutorialText.textContent = slides[newSlide] ? slides[newSlide].text : '';

            gsap.to(this.currentData, {
                transform: transform, duration: 0.3, onUpdate: () => {
                    slider.style.transform = `translateX(${-this.currentData.transform}%)`;
                }
            })

            if (newSlide + 1 === this.currentData.spans.length) {
                nextTipBtn.style.display = 'none';
                startBtn.style.display = 'block';
            }
    }

    public static deleteNodes(): void {
        const slider = document.getElementById('slider');
        slider.style.transform = `translateX(0%)`;
        for (let i = 0; i < this.newNodes.length; i++) {
            const node = this.newNodes[i];
            node.remove();
        }
    }

    private static changeSlide(slide, span, text): void {
        this.currentData.slide = slide;
        const slider = document.getElementById('slider');
        const transform = slide * 100;
        const startBtn = document.getElementById('startLevel');
        const nextTipBtn = document.getElementById('nextTip');
        const activeSpan = document.getElementsByClassName('active')[0];
        const tutorialText = document.getElementById('tutorialText');
        activeSpan.classList.remove('active');
        span.classList.add('active');
        tutorialText.textContent = text;

        gsap.to(this.currentData, {
            transform: transform, duration: 0.3, onUpdate: () => {
                slider.style.transform = `translateX(${-this.currentData.transform}%)`;
            }
        })
        if (slide < this.currentData.spans.length - 1) {
            nextTipBtn.style.display = 'block';
            startBtn.style.display = 'none';
        } else {
            nextTipBtn.style.display = 'none';
            startBtn.style.display = 'block';
        }
    }

    public static saveTutorial(data) {
        if (config.guest) {
            
        } else {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${config.path}`);
            myHeaders.append("Cookie", ".ASPXAUTH=FEF6BD449BABA7C05D4CCD2FAAA62D5881EBB0BE5AAB5391753B3BBA4757CDB0646A2347B0FDC0988581F0160B305CCD80C466D386143BD222EF00BE8BFD7E2F4DD366BC1BE8EEE3D8FD5732961281DF0169143498B2E0D6912B546ED8229BA97036234B06A72B440AF6431A50AC31BE6266DFCAF1B8FE58579F169625A6330200368389DC17BA20D54AA6737DAD151751B71418263097FA3C5B78599FE2EB46F502CBF3; ASP.NET_SessionId=wtmowiwiijmo3ql0e0mvg3rg; SCAuth=0BA9B111516D4A011AB74D900DF1212003B6D6C60EAD304A0F29D787D57313316D7CED8D6B09CC1BF79418EBE16BE2994FDDD53ADE5045A24C0301E1EC3681FA0705AB8D0416CEAB5EB73C87378D70917A3574C982ACA083265019963BDE8CDCE0264E8BD20634291795FF865CED752B2B2A5C03468160AA03A3D47F79F550BA863A4DA29D5CFD4D47A4455D05565D5C51F1B3FD6BBF11A8916605F5EEF100878A3753BE18692E00F3CBAAB2F6F51F32B7AC06C5738961EF0E5FD12297DD58D1E58C2786E6621123C27D5D28B8045913BED03875; SC_ANALYTICS_GLOBAL_COOKIE=51cfea77889a44c5bac6166f760082f3|False; UserAuthentication=authenticated=yes&user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&last_user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&lg_key=d8573f02-731b-436b-ba66-4d70ed086551&geoIP=none; __RequestVerificationToken=PzIutvsJQPKK1L6tbKEHYKkmKhq8igH-0hUoXMTXZCimf6a69HRTOSHwODivkPXSIwkgJOE8uWxGjIVVBUt-k9LfpTQ1; cookiesession1=678A3E0DVWXYZABDEFGHIJKLMNOPD1B5; mny_visitor=visitor#=125624013&showmnynow=y; reinfo=0; sc_expview=0");

            const requestOptions = {
                method: 'PUT',                
                credentials: 'include',
                headers: {
                    ContentType: 'application/json;charset=utf-8',
                    // Authorization: `Bearer ${config.token}`,
                },
            };
            //@ts-ignore
            fetch(`${config.path}/match-game/tutorials?userId=${config.playerId}&drop_product=${data.drop_product}&background_release=${data.background_release}&fill_bar=${data.fill_bar}`, requestOptions)
                .then(response => response.text())
                .then(result => console.log(result))
                .catch(error => console.log('error', error));  
        }
        
    }
}